import { GET_PUBLISHED_VERSIONS_SUCCESS } from './versions.types';

const initialState = {
    publishedVersions: [],
};

export const versionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PUBLISHED_VERSIONS_SUCCESS:
            return {
                ...state,
                publishedVersions: action.payload,
            };
        default:
            return state;
    }
};
